import i18n from '@/translations/i18n';

export default {
    required: value => !!value || value === 0 || i18n.t('errors.required'),
    email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return !value || pattern.test(value) || i18n.t('errors.invalidEmail');
    },
    password: value => {
        const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
        return !value || re.test(value) || i18n.t('errors.passwordFormat');
    },
    number: value => {
        const re = /^[0-9]+$/;
        return !value || re.test(value) || i18n.t('errors.numberFormat');
    },
    numberDecimal: value => {
        const re = /^-?\d+(\.\d{1,20})?$/;
        return !value || re.test(value) || i18n.t('errors.numberDecimalFormat');
    },
    hexColor: value => {
        const re = /^#[0-9A-F]{6}$/i;
        return !value || re.test(value) || i18n.t('errors.notValidColor');
    },
    time: value => {
        const re = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
        return !value || re.test(value) || i18n.t('errors.notValidTime');
    }
};